// extracted by mini-css-extract-plugin
export var opgBorderColor = "#d6dae2";
export var opgAzureBlue = "#056dff";
export var opgBorderRadius = "10px";
export var opgBorderWidth = "1px";
export var opgElementSpacing = "8px";
export var opgColorIcon = "#74757b";